import type { User } from '../types/auth';
import { APP_HOME, canUseMarketingSegment } from './segment';

const KEY = 'snapfy_post_auth_redirect';
/** Um dia: tempo de criar a conta e confirmar o e-mail. */
const TTL_MS = 24 * 60 * 60 * 1000;

/**
 * Para onde ir depois do login/cadastro quando a pessoa começou na landing
 * (ex.: colou o link da loja → DNA da marca com o link preenchido). Fica no
 * localStorage porque o cadastro passa pela confirmação de e-mail (que pode
 * abrir em outra aba) e pelo login social (que sai do site e volta).
 */
export const setPostAuthRedirect = (path: string): void => {
  if (!path.startsWith('/') || path.startsWith('//')) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }));
  } catch {
    /* storage indisponível: cai na home do app */
  }
};

/** Lê e apaga o destino pendente (null se não houver ou se expirou). */
export const takePostAuthRedirect = (): string | null => {
  try {
    const raw = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
    if (!raw) return null;
    const { path, at } = JSON.parse(raw) as { path?: string; at?: number };
    if (typeof path !== 'string' || typeof at !== 'number' || Date.now() - at > TTL_MS) return null;
    return path.startsWith('/') && !path.startsWith('//') ? path : null;
  } catch {
    return null;
  }
};

/** Início da plataforma para o usuário: o Marketing para quem tem acesso a ele; senão, o Product Studio. */
export const platformHome = (user: User | null | undefined): string => (canUseMarketingSegment(user) ? '/marketing' : APP_HOME);

/** Destino depois de entrar: o pedido na landing, se houver; senão, o início da plataforma. */
export const resolvePostAuthPath = (user: User | null | undefined): string => takePostAuthRedirect() ?? platformHome(user);
